import { lazyLoad } from '@utils/router'
import Home from '@themes/horizontal/views/Home'
import knowledgeRoutes from '@views/KnowledgeLib/route'
enum ModuleEnum {
  'HOME' = 'HOME', // 首页
  'COURSE' = 'COURSE', // 资源中心的路由
  'VIDEO' = 'VIDEO', // 短视频的路由
  'LIVE' = 'LIVE', // 直播的路由
  'EXAM' = 'EXAM', // 学考中心的路由
  'TRAIN' = 'TRAIN', // 培训中心的路由
  'INFO' = 'INFO', // 资讯中心的路由
  'KNOWLEDGE' = 'KNOWLEDGE', // 文库
  'PROFESSOR' = 'PROFESSOR', // 教官中心的路由
  'PERSONAL' = 'PERSONAL', // 个人中心的路由
  'CLOUD_SCHOOL_TRAIN' = 'CLOUD_SCHOOL_TRAIN', // 云校我的培训项目
}

const routes = [
  {
    path: '/home/resetPassword',
    component: lazyLoad(() =>
      import('@themes/horizontal/views/ResetPassword')
    ),
  },
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: '/home/myExam',
        component: lazyLoad(() =>
          // import('@themes/horizontal/views/MyExam')
          import('@views/MyExam')
        ),
        module: ModuleEnum.HOME,
      },
      {
        path: '/home/publicExam',
        component: lazyLoad(() => import('@views/PublicExam')),
        module: ModuleEnum.EXAM,
      },
      {
        path: '/home/examDetail/:examId',
        component: lazyLoad(() => import('@views/ExamDetail')),
      },
      {
        path: '/home/examScoreRank/:examId',
        component: lazyLoad(() => import('@views/ExamScoreRank')),
      },
      {
        path: '/home/trainingExamDetail/:examId/:trainingItemId',
        component: lazyLoad(() => import('@views/TrainingExamDetail')),
      },
      {
        path: '/home/course',
        component: lazyLoad(() => import('@themes/horizontal/views/Course')),
        module: ModuleEnum.COURSE,
      },
      {
        path: '/home/homePage',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/HomePage')
        ),
        module: ModuleEnum.HOME, // 所属频道，根据增值服务或频道列表判断是否加载路由
      },
      {
        path: '/home/inforList',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/InforList')
        ),
        module: ModuleEnum.INFO,
      },
      {
        path: '/home/personalCenter',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/PersonalCenter')
        ),
        module: ModuleEnum.PERSONAL,
      },
      {
        path: '/home/resource/:id',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/NewColumn')
        ),
        module: ModuleEnum.HOME,
      },
      {
        path: '/home/linkResource/:id/:name',
        component: lazyLoad(() => import('@themes/horizontal/views/Course')),
        module: ModuleEnum.HOME,
      },
      {
        path: '/home/trainerCenter',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/TrainerCenter')
        ),
        module: ModuleEnum.TRAIN,
      },
      {
        path: '/home/myCourseTrainer',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/TrainerCenter/CourseList')
        ),
        module: ModuleEnum.COURSE,
      },
      {
        path: '/home/myLive',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/TrainerCenter/LiveList')
        ),
        module: ModuleEnum.TRAIN,
      },
      {
        path: '/home/myTrain',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/TrainerCenter/TrainList')
        ),
        module: ModuleEnum.TRAIN,
      },
      ...knowledgeRoutes.map(r => ({ ...r, module: 'KNOWLEDGE' })),
      {
        path: '/home/myIntegration/detail',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/Integration/Detail')
        ),
        module: ModuleEnum.PERSONAL,
      },
      {
        path: '/home/myIntegration/rule',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/Integration/Rule')
        ),
        module: ModuleEnum.PERSONAL,
      },
      {
        path: '/home/certificate/list',
        component: lazyLoad(() =>
          import('@themes/horizontal/views/Certificate/index')
        ),
        module: ModuleEnum.PERSONAL,
      },
      {
        path: 'home/trainingProjectList',
        component: lazyLoad(() =>
          import('@views/HumanTraining/trainingProject/index')
        ),
        module: ModuleEnum.PERSONAL,
      },

      // 公开培训项目-列表-面包屑为：培训项目
      {
        path: '/home/openTrainingProjectList',
        component: lazyLoad(() => import('@views/OpenTrainProjects')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },
      // 公开培训项目-详情
      {
        path: '/home/openTrainingDetail',
        component: lazyLoad(() =>
          import('@views/OpenTrainProjects/constain/trainingDetail')
        ),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },

      // 我的培训项目-列表
      {
        path: '/home/myTrainingProjectList',
        component: lazyLoad(() => import('@views/MyTrainingProject')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },

      // 培训报名-支付
      {
        path: '/home/openTrainingSign',
        component: lazyLoad(() => import('@views/SignTrain')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },

      // 培训报名-开票
      {
        path: '/home/billing',
        component: lazyLoad(() => import('@views/ApplyBill')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },
      {
        path: '/home/billingSuccess',
        component: lazyLoad(() =>
          import('@views/ApplyBill/constain/success')
        ),
      },

      // 我的订单
      {
        path: '/home/myOrder',
        component: lazyLoad(() => import('@views/MyOrder')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },
      // 我的订单-详情
      {
        path: '/home/myOrderDetail',
        component: lazyLoad(() => import('@views/MyOrder/contains/orderDetail')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },

      // 退款售后
      {
        path: '/home/refundSale',
        component: lazyLoad(() => import('@views/RefundSale')),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },
      // 退款售后详情
      {
        path: '/home/refundSaleDetail',
        component: lazyLoad(() =>
          import('@views/RefundSale/constain/refundDetail')
        ),
        module: ModuleEnum.CLOUD_SCHOOL_TRAIN,
      },
    ],
  },
]

export default routes
